module.exports = __webpack_public_path__ + "static/blog65-33a738a4a15e282cfc4035479db8c54f.png";